<template>
  <div style="background-color: white">
    <v-toolbar dark class="secondary">
      <v-icon>person_outline</v-icon>
      <v-toolbar-title>{{ type === 'edit' ? 'Edit Additional Contact' : 'Add Additional Contact' }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field v-model="name" :rules="validationRequired" label="Name" />
        </v-flex>
        <v-flex xs6>
          <v-text-field v-model="email" :rules="emailRules" label="Email" />
        </v-flex>
        <v-flex xs6 class="pl-3">
          <v-text-field mask="phone" v-model="phone" label="Phone" />
        </v-flex>
      </v-layout>
      <v-flex>
        <v-btn :disabled="!valid" flat class="primary" @click="type === 'edit' ? editContact() : addAdditionalContact()"><v-icon left>person</v-icon>Save and Close</v-btn>
        <v-btn flat class="secondary" @click="$emit('closeDialog')">Cancel</v-btn>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ['project', 'editAdditionalContact'],
  data () {
    return {
      previousState: null,
      type: 'new',
      valid: true,
      name: null,
      email: null,
      phone: null,
      validationRequired: [
        v => !!v || 'Field is required'
      ],
      emailRules: [
        // v => !!v || 'E-mail is required',
        v => v ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid' : true
      ]
    }
  },
  mounted () {
    if ((this.editAdditionalContact && this.editAdditionalContact.index) || (this.editAdditionalContact && this.editAdditionalContact.index === 0)) {
      this.previousState = this.project.additional_contacts[this.editAdditionalContact.index]
      this.type = 'edit'
      this.name = this.previousState.name
      this.email = this.previousState.email
      this.phone = this.previousState.phone
    }
  },
  methods: {
    editContact () {
      this.project.additional_contacts.splice(this.editAdditionalContact.index, 1)
      this.project.additional_contacts.splice(this.editAdditionalContact.index, 0, { name: this.name, email: this.email, phone: this.phone, deleted: false })
      this.$store.dispatch('additionalContact', { project: this.project, type: 'edit', newContact: this.name })
      this.$emit('closeDialog')
    },
    addAdditionalContact () {
      if (!this.project.additional_contacts) {
        this.project.additional_contacts = []
      }
      this.project.additional_contacts.push({ name: this.name, email: this.email, phone: this.phone, deleted: false })
      this.$store.dispatch('additionalContact', { project: this.project, type: 'new', newContact: this.name })
      this.$emit('closeDialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/AdditionalContact.vue